module.exports = __webpack_public_path__ + "static/media/yesNo.1b1fd135.svg";